<template>
  <div class="p-short-operate-wrap">
    <div class="p-short-operate_title">
      <em class="ibass ibass-arrow-next"></em>
      快捷操作
    </div>

    <div class="p-short-operate_operation">
      <ul>
        <li @click="fillingApplicate">立案申请</li>
        <li @click="conflictPre" v-if="!platform">利冲预检</li>
        <li @click="launchAppro" v-if="!platform">发起审批</li>
        <li @click="addTask">新建任务</li>
        <li @click="goSearchReport">检索报告</li>
        <li @click="addTime">添加计时</li>
      </ul>
    </div>
  </div>
</template>
<script>
import indexService from '../../service/index'
export default {
  name: 'PShortcutOperate',
  props: {},
  data () {
    return {
      fillingApplicateDisabled: false, // 禁用立案申请按钮
      conflictPreCheckDisabled: false, // 禁用利冲预检按钮
      conflictMember: false, // 是不是利冲成员
      conflictPreCheck: false, // 是不是利冲预检成员
      isFinancialManager: false, // 是否有财务管理员权限
      newLawFirm: true, // 新所
      platform: false, // 平台
      openApprove: true, // 是否打开审批
      Domain: process.env.VUE_APP_IFRAME_DOMAIN
    }
  },
  computed: {},
  mounted () {
    // 获取立案申请权限
    this.getApplyMatter()
    // 获取利冲预检权限
    this.getConflictPreCheck()
    // 获取发起审批权限
    this.getApprove()
    // 获取新增合同权限
    this.getContract()
  },
  methods: {
    async getApplyMatter () {
      let response = null
      response = await indexService.getShortCutOperateAuthority('APPLY_MATTER')
      if (response.isSuccess) {
        this.fillingApplicateDisabled = response.data.hasRight
      } else {
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    async getConflictPreCheck () {
      let response = null
      response = await indexService.getShortCutOperateAuthority('CONFLICT_PRE_CHECK')
      if (response.isSuccess) {
        this.newLawFirm = response.data.newLawFirm
        this.conflictPreCheckDisabled = response.data.conflictManager
        this.conflictMember = response.data.conflictMember
        this.conflictPreCheck = response.data.conflictPreCheck
      } else {
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    async getApprove () {
      let response = null
      response = await indexService.getShortCutOperateAuthority('APPROVE')
      if (response.isSuccess) {
        this.platform = response.data.platform
      } else {
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    async getContract () {
      let response = null
      response = await indexService.getShortCutOperateAuthority('CONTRACT')
      if (response.isSuccess) {
        this.openApprove = response.data.openApprove
        this.isFinancialManager = response.data.financialManager
      } else {
        this.$postMessage.toast({ msg: response.message || response.resultMsg })
      }
    },
    fillingApplicate () {
      if (!this.fillingApplicateDisabled) {
        return this.$postMessage.toast({ msg: '您暂无此操作的权限，请尝试联系系统管理员' })
      }
      this.$analysis.track('立案申请_快捷操作/工作台模块')
      window.parent.postMessage({
        action: 'fromWorkFlatFillingApplicate'
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    },
    conflictPre () {
      if (this.newLawFirm) {
        // 不是利冲管理员
        if (!this.conflictPreCheckDisabled) {
          // 是利冲成员并且开启了利冲预检
          if (this.conflictMember && this.conflictPreCheck) {
            this.$analysis.track('利冲检索_快捷操作/工作台模块')
            window.open(this.Domain + '/#/app/conflict/search')
          } else {
            return this.$postMessage.toast({ msg: '您暂无此操作的权限，请尝试联系系统管理员' })
          }
        } else {
          this.$analysis.track('利冲检索_快捷操作/工作台模块')
          window.open(this.Domain + '/#/app/conflict/search')
        }
      } else {
        return this.$postMessage.toast({ msg: '您的系统未升级最新的律所管理版本，可联系小橙子进行升级' })
      }
    },
    launchAppro () {
      this.$analysis.track('发起审批_快捷操作/工作台模块')
      window.parent.postMessage({
        action: 'fromWorkFlatLaunchAppro',
        data: {
          type: 'approvals'
        }
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    },
    addTask () {
      this.$analysis.track('新建任务_快捷操作/工作台模块')
      window.parent.postMessage({
        action: 'fromWorkFlatAddTask'
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    },
    // addContract () {
    //   if (this.newLawFirm) {
    //     // 新所开启合同审批
    //     if (this.openApprove) {
    //       this.$analysis.track('新增合同_快捷操作/工作台模块')
    //       window.parent.postMessage({
    //         action: 'fromWorkFlatAddContract'
    //       }, process.env.VUE_APP_IFRAME_DOMAIN)
    //     } else {
    //       return this.$postMessage.toast({ msg: '请到具体项目的财务下添加合同' })
    //     }
    //   } else {
    //     // 平台版
    //     if (this.platform) {
    //       return this.$postMessage.toast({ msg: '请到具体项目的财务下添加合同' })
    //     } else {
    //       // 旧所 财务管理员权限
    //       if (this.isFinancialManager) {
    //         this.$analysis.track('新增合同_快捷操作/工作台模块')
    //         window.parent.postMessage({
    //           action: 'fromWorkFlatAddContractNoneFinancialManager'
    //         }, process.env.VUE_APP_IFRAME_DOMAIN)
    //       } else {
    //         return this.$postMessage.toast({ msg: '请到具体项目的财务下添加合同' })
    //       }
    //     }
    //   }
    // },
    goSearchReport () {
      this.$analysis.track('检索报告_快捷操作/工作台模块')
      window.open(this.Domain + '/#/bigdata-app/report')
    },
    addTime () {
      this.$analysis.track('添加计时_快捷操作/工作台模块')
      window.parent.postMessage({
        action: 'fromWorkFlatAddTime'
      }, process.env.VUE_APP_IFRAME_DOMAIN)
    }
  }
}
</script>
<style lang="stylus" scoped>
.p-short-operate-wrap
  width 100%
  margin 0 auto
  padding 22px 24px 24px
  box-sizing border-box
  overflow hidden
  .p-short-operate_title
    display flex
    align-items center
    color #ED6C00
    font-size 14px
    em
      margin-right 12px
      margin-top 5px
      tranform rotateZ(-45deg)
      -webkit-transform rotateZ(-45deg)
  .p-short-operate_operation
    margin-top 12px
    ul
      display flex
      flex-flow row wrap
      margin-left -10px
      margin-top -10px
      &:first-child
        margin-bottom 11px
      li
        width 68px
        height 30px
        line-height 30px
        text-align center
        flex: 0 0 28%
        margin-left 10px
        margin-top 10px
        background #F8F8F8
        border 1px solid #ECECEC
        border-radius 3px
        font-size 12px
        color #212121
        &:hover
          cursor pointer
          color #ED6C00
</style>
